import { useTheme } from "@/contexts/ThemeContext";
import { Moon, Sun } from "lucide-react";
import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";

interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Hidrasyon uyumsuzluğunu önlemek için
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  // Geçerli temanın "dark" olup olmadığını kontrol et
  const isDarkTheme = theme === "dark" || 
    (theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);

  return (
    <button
      onClick={() => setTheme(isDarkTheme ? "light" : "dark")}
      className={cn(
        "relative inline-flex h-6 w-11 items-center rounded-full transition-colors",
        "bg-muted border border-input shadow-sm",
        isDarkTheme ? "bg-primary border-primary" : "",
        className
      )}
      aria-label="Temayı değiştir"
    >
      <span
        className={cn(
          "flex h-5 w-5 transform items-center justify-center rounded-full bg-background",
          "transition-transform duration-300 ease-spring",
          "shadow-sm absolute",
          isDarkTheme ? "translate-x-5" : "translate-x-0"
        )}
      >
        {isDarkTheme ? (
          <Moon size={14} className="text-primary animate-fade-in" />
        ) : (
          <Sun size={14} className="text-primary animate-fade-in" />
        )}
      </span>
      <span className="sr-only">
        {isDarkTheme ? "Açık tema" : "Koyu tema"}
      </span>
    </button>
  );
} 